<template>
    <div class="program-view-wrapper pb20">
        <a-spin :spinning="spinning" tip="Loading...">
            <a-card size="small" :title="$t('program.slide_admin'/*幻灯管理员*/)">
                <a-button type="primary" @click="$refs.editSlideUserModal.showFun()">{{$t('program.slide_admin_manage'/*试片室客户端管理员管理*/ )}}</a-button>
                <a-table :columns="columns" :dataSource="userList" :pagination="false" class="mt20">
                    <template slot="action" slot-scope="text, record, index">
                        <a @click="$refs.editSlideUserModal.showFun(record)">
                            {{$t('layout.edit')}}
                        </a>
                        <a-divider type="vertical" />
                        <a class="del-button" @click="handleDelUserEvent(record.id, index)">
                            {{$t('layout.delete')}}
                        </a>
                    </template>
                </a-table>
            </a-card>
            <a-form :form="form">
                <a-form-item :label="$t('program.slide_download'/*幻灯客户端下载*/)">
                    <a :href="configInfo.down_url">
                        <a-button type="primary">{{$t('program.click_download'/*点击下载*/ )}}</a-button>
                    </a>
                </a-form-item>

                <a-form-item :label="$t('program.bold_name'/*是否开启姓名字体加粗*/)">
                    <a-radio-group v-decorator="['name_org_is_blod', { rules: [{ required: true, message: $t('program.choose_bold_name'/*请选择是否开启姓名字体加粗*/ ) }] }]">
                        <a-radio :value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                        <a-radio :value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item :label="$t('program.font_color'/*字体颜色设置*/)">
                    <color-picker v-decorator="['name_org_color']"></color-picker>
                </a-form-item>

                <a-form-item :label="$t('program.upload_image'/*上传图片*/)">
                    <a-upload
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        :action="uploadImageUrl"
                        :data="{ type: 1 }"
                        :before-upload="(event) => beforeUpload(event, 'img')"
                        :headers="uploadHeaders"
                        @change="handleChange($event, { fieldName: 'judged_picture', loading: 'loading_v1' })"
                    >
                        <input type="hidden" v-decorator="['judged_picture', { rules: [{ required: true, message: $t('program.upload_cover'/*请上传封面图*/ ) }] } ]" />
                        <a-spin v-if="form.getFieldValue('judged_picture')" :spinning="loading_v1">
                            <img style="max-width: 100%" :src="form.getFieldValue('judged_picture') | urlFilter(250)" alt="file" />
                        </a-spin>
                        <!--  上传图片 -->
                        <div v-else>
                            <a-icon :type="loading_v1 ? 'loading' : 'plus'" />
                            <div class="ant-upload-text">{{$t('program.upload_image'/*上传图片*/ )}}</div>
                        </div>
                    </a-upload>
                    <template slot="extra">
                        <p class="error-color">
                            {{$t('program.suggest_size'/*建议尺寸1280*720px ，支持JPG,PNG图片文件,图片大小最大2M*/ )}}
                        </p>
                    </template>
                </a-form-item>

                <a-form-item :label="$t('program.slide_background'/*直播背景图*/)">
                    <a-upload
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        :action="uploadImageUrl"
                        :data="{ type: 1 }"
                        :before-upload="(event) => beforeUpload(event, 'img')"
                        :headers="uploadHeaders"
                        @change="handleChange($event, { fieldName: 'back_pic', loading: 'loading_v2' })"
                    >
                        <input type="hidden" v-decorator="['back_pic', { rules: [{ required: true, message: $t('program.upload_cover'/*请上传封面图*/ ) }] } ]" />
                        <a-spin v-if="form.getFieldValue('back_pic')" :spinning="loading_v1">
                            <img style="max-width: 100%" :src="form.getFieldValue('back_pic') | urlFilter(250)" alt="file" />
                        </a-spin>
                        <!--  上传图片 -->
                        <div v-else>
                            <a-icon :type="loading_v1 ? 'loading' : 'plus'" />
                            <div class="ant-upload-text">{{$t('program.upload_image'/*上传图片*/ )}}</div>
                        </div>
                    </a-upload>
                    <template slot="extra">
                        <p class="error-color">
                            {{$t('program.suggest_size'/*建议尺寸1280*720px ，支持JPG,PNG图片文件,图片大小最大2M*/ )}}
                        </p>
                    </template>
                </a-form-item>

                <a-form-item :label="$t('program.meeting_notice'/*会场通知*/)">
                    <a-upload
                        :action="uploadImageUrl"
                        :show-upload-list="false"
                        :data="{ type: 1 }"
                        :headers="uploadHeaders"
                        :before-upload="(event) => beforeUpload(event, 'file')"
                        @change="handleChange($event, { fieldName: 'meeting_hall_notice', loading: 'loading_v3' })">
                        <a-button>
                            <a-icon :type="loading_v3 ? 'loading' : 'upload'" />
                            {{$t('program.upload_file'/*上传文件*/ )}}
                        </a-button>
                        <div class="flex x-left mt10" v-if="form.getFieldValue('meeting_hall_notice')">
                            <a :href="'https://files.sciconf.cn/' + form.getFieldValue('meeting_hall_notice')" target="_blank">{{$t('program.view_file'/*查看*/ )}}</a>
                        </div>
                        <a-input type="hidden" v-decorator="['meeting_hall_notice', { rules: [{ required: true, message: $t('program.please_upload_meeting_notice'/*请上传会场会议通知*/ ) }] } ]" />
                    </a-upload>
                    <template slot="extra">
                        <p class="error-color">{{$t('program.only_pps'/*只能上传.pps类型文件*/ )}}</p>
                    </template>
                </a-form-item>

                <a-form-item :label="$t('program.open_speaker_upload'/*是否开启前台上传讲者PPT功能*/)">
                     <a-radio-group v-decorator="['is_open_slide_upload', { rules: [{ required: true, message: $t('program.choose_open_speaker_upload'/*请选择是否开启前台上传讲者PPT功能*/ ) }] }]">
                        <a-radio :value="1">{{$t('program.open'/*开启*/ )}}</a-radio>
                        <a-radio :value="0">{{$t('program.close'/*关闭*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item :label="$t('program.file_version_type'/*收集文件版本类型*/)">
                    <a-radio-group v-decorator="['is_version_type', { rules: [{ required: true, message: $t('program.choose_file_version_type'/*请选择收集文件版本类型*/ ) }] }]">
                        <a-radio :value="1">{{$t('program.bilingual'/*双语*/ )}}</a-radio>
                        <a-radio :value="2">{{$t('program.monolingual'/*单语*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item :label="$t('program.open_slide_audit'/*是否开启专题会上传幻灯ppt审核*/)">
                    <a-radio-group v-decorator="['is_open_auth', { rules: [{ required: true, message: $t('program.choose_open_slide_audit'/*请选择是否开启专题会上传幻灯ppt审核*/ ) }] }]">
                        <a-radio :value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        <a-radio :value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item :label="$t('program.speaker_upload_deadline'/*前台上传讲者PPT截止时间*/)">
                    <a-date-picker value-format="YYYY-MM-DD hh:mm:ss" format="YYYY-MM-DD hh:mm:ss" style="width:250px;" v-decorator="['upload_cut_time', { rules: [{ required: true, message: $t('program.choose_speaker_upload_deadline'/*请选择前台上传讲者PPT截止时间*/ ) }] } ]" show-time :placeholder="$t('program.choose_speaker_upload_deadline'/*请选择前台上传讲者PPT截止时间*/ )"/>
                </a-form-item>

                <a-form-item :label="$t('program.cut_content_cn'/*截止后提示内容（中文）*/)">
                    <tinymce-editor :height="400" v-decorator="['cut_content']" :type="2"></tinymce-editor>
                </a-form-item>

                <a-form-item :label="$t('program.cut_content_en'/*截止后提示内容（英文）*/)">
                    <tinymce-editor :height="400" v-decorator="['cut_content_en']" :type="2"></tinymce-editor>
                    <template slot="extra">
                        <div class="error-color">
                            <p>{{$t('program.cut_content_example1'/*例：本次会议线上课件收集已截止！可至会场上传：*/ )}}</p>
                            <p>{{$t('program.cut_content_example2'/*试片室地点：XX博览中心A馆XXX房间*/ )}}</p>
                            <p>{{$t('program.cut_content_example3'/*试片室工作时间：*/ )}}</p>
                            <p>{{$t('program.cut_content_example4'/*11月16日 13:00-19:00*/ )}}</p>
                            <p>{{$t('program.cut_content_example5'/*11月17日 07:15-17:30*/ )}}</p>
                            <p>{{$t('program.cut_content_example6'/*11月18日 07:30-17:30*/ )}}</p>
                            <p>{{$t('program.cut_content_example7'/*11月19日 07:30-11:00*/ )}}</p>
                        </div>
                    </template>
                </a-form-item>

                <a-form-item :label="$t('program.live_mode'/*直播模式*/)">
                     <a-radio-group v-decorator="['live_speaker_type', { rules: [{ required: true, message: $t('program.choose_live_mode'/*请选择直播模式*/ ) }] }]">
                        <a-radio :value="1">{{$t('program.three_screen'/*三连屏*/ )}}</a-radio>
                        <a-radio :value="2">{{$t('program.ppt'/*PPT*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-button type="primary" @click="$refs.localVideoModalRef.showFun()">{{$t('program.view_local_video_list'/*查看本地录制视频列表*/ )}}</a-button>

                <a-form-item :label="$t('program.open_cloud_record'/*是否开启云录制*/)">
                    <a-radio-group v-decorator="['is_open_record_z', { rules: [{ required: true, message: $t('program.choose_open_cloud_record'/*请选择是否开启云录制*/ ) }] }]">
                        <a-radio :value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        <a-radio :value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <div v-show="form.getFieldValue('is_open_record_z') == 1">
                    <a-form-item :label="$t('program.cloud_record_schedule'/*云录制关联日程*/)">
                        <a-radio-group v-decorator="['is_record_gl_program', { rules: [{ required: form.getFieldValue('is_open_record_z') == 1, message: $t('program.choose_cloud_record_schedule'/*请选择云录制关联日程*/ ) }] }]">
                            <a-radio :value="-1">{{$t('program.cloud_record_unit_no'/*单元否*/ )}}</a-radio>
                            <a-radio :value="1">{{$t('program.cloud_record_unit_yes'/*单元是*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item :label="$t('program.cloud_record_mode'/*云录制模式*/)">
                        <a-radio-group v-decorator="['record_speaker_type', { rules: [{ required: form.getFieldValue('is_open_record_z') == 1, message: $t('program.choose_cloud_record_mode'/*请选择云录制模式*/ ) }] }]">
                            <a-radio :value="1">{{$t('program.three_screen'/*三连屏*/ )}}</a-radio>
                            <a-radio :value="2">{{$t('program.ppt'/*PPT*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <div>
                        <a-button type="primary" @click="$refs.cloudVideoModalRef.showFun()">{{$t('program.view_cloud_video_list'/*查看云录制视频列表*/ )}}</a-button>
                        <a-button class="ml10" type="primary" @click="$refs.localVideoModalRef.showFun()">{{$t('program.view_local_video_list'/*查看本地录制视频列表*/ )}}</a-button>
                    </div>
                </div>
            </a-form>
            <div class="t-c mt20">
                <a-button style="width:200px" type="primary" @click="handleSubmitEvent">{{$t('program.save'/*保存*/ )}}</a-button>
            </div>
        </a-spin>
        <edit-slide-user-modal ref="editSlideUserModal" @reset="getSlideUserList"/>
        <local-video-modal ref="localVideoModalRef"/>
        <cloud-video-modal ref="cloudVideoModalRef"/>
    </div>
</template>
<script>
import editSlideUserModal from './components/edit-slide-user-modal.vue'
import localVideoModal from './components/local-video-modal.vue'
import cloudVideoModal from './components/cloud-video-modal.vue'
import userApi from '@/request/apiList'
import tinymceEditor from '@/components/Tinymce/index.vue';
import pick from 'lodash.pick';
const fileds = ['name_org_is_blod', 'name_org_color', 'judged_picture', 'back_pic', 'meeting_hall_notice', 'is_open_slide_upload', 
'is_version_type', 'is_open_auth', 'upload_cut_time', 'cut_content', 'cut_content_en', 'live_speaker_type', 'is_open_record_z',
'is_record_gl_program', 'record_speaker_type'
];
import ColorPicker from '@/components/ColorPicker'
import { values } from 'store/storages/all'
export default {
    name: 'slideConfig',
    components: {
        ColorPicker,
        editSlideUserModal,
        tinymceEditor,
        localVideoModal,
        cloudVideoModal
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this),
            spinning: false,
            columns: [
                 {
                    title: this.$t('program.user_name'/*用户名*/),
                    dataIndex: 'user_name',
                    align: 'center',
                },
                {
                    title: this.$t('program.login_password'/*密码*/),
                    dataIndex: 'password',
                    align: 'center',
                },
                {
                    title: this.$t('layout.operation'),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    fixed: 'right'
                }
            ],
            userList: [],
            configInfo: {},
            // 文件请求头
            uploadHeaders: {},
            // 文件请求地址
            uploadImageUrl: userApi.uploadImage,
            loading_v1: false,
            loading_v2: false,
            loading_v3: false
        };
    },
    methods: {
        handleDelUserEvent (admin_id, index) {
            this.$confirm({
                title: this.$t('web.tips'/*提示*/),
                content: this.$t('program.confirm_delete_user'/*确定要删除该用户吗？*/),
                okText: this.$t('web.ok'/*确定*/),
                cancelText: this.$t('web.cancel'/*取消*/),
                onOk: () => {
                    this.$request.post({ url: 'delSlideUser', data: { admin_id } }).then(res => {
                        this.$message.success(this.$t('authority.delete_success'/*删除成功*/));
                        this.userList.splice(index, 1)
                    });
                }
            });
        },
        getSlideUserList () {
            this.$request.get({ url: 'getSlideUserList' }).then((res) => {
                this.userList = res.data
            })
        },
        getSlideConfig () {
            this.spinning = true
            this.$request.get({ url: 'getSlideConfig' }).then((res) => {
                this.configInfo = res.data
                this.form.setFieldsValue(pick(this.configInfo, fileds))
            }).finally(() => {
                this.spinning = false
            })
        },
        handleSubmitEvent () {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.spinning = true
                    this.$confirm({
                        title: this.$t('web.tips'/*提示*/),
                        content: this.$t('program.confirm_submit_change'/*是否要提交更改?*/),
                        okText: this.$t('web.ok'/*确定*/),
                        cancelText: this.$t('web.cancel'/*取消*/),
                        onOk: () => {
                            values.is_open_record = values.is_open_record_z
                            delete values.is_open_record_z
                            values.is_blod = values.name_org_is_blod
                            delete values.name_org_is_blod
                            values.font_color = values.name_org_color
                            delete values.name_org_color
                            this.$request.post({ url: 'saveSlideConfig', data: { ...values, set_id: this.configInfo.id } }).then((res) => {
                                this.$message.success(this.$t('program.save_success'/*保存成功*/));
                            }).finally(() => {
                                this.spinning = false
                            })
                        },
                        onCancel: () => {
                            this.spinning = false
                        }
                    });
                }
            })
        },
        // 上传修改
        handleChange(info, { fieldName, loading }) {
            if (info.file.status === 'uploading') {
                this[loading] = true;
                return;
            }
            if (info.file.status === 'done') {
                let { code, data, message } = info.file.response;
                if (code == 200) {
                    let obj = {};
                    obj[fieldName] = data.relative_path;
                    this.form.setFieldsValue(obj);
                } else {
                    this.$message.error(message);
                }
                this[loading] = false;
            }
        },

        // 上传前
        beforeUpload(file, type) {
            return new Promise((resolve, reject) => {
                // 头像的验证
                let regFile = file.type === 'image/jpeg' || file.type === 'image/png'
                if (type == 'file') {
                    regFile = file.type == 'application/vnd.ms-powerpoint'
                }
                if (!regFile) {
                    if (type == 'img') {
                        this.$message.error(this.$t('forum.you_can_only_upload_image_files')); //  您只能上传图像文件
                    } else {
                        this.$message.error(this.$t('program.only_pps_type_file'/*您只能上传.pps类型文件*/)); //  您只能上传图像文件
                    }
                    return reject(regFile);
                }
                return resolve(regFile);
            });
        }
    },
    created () {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
        fileds.forEach(v => this.form.getFieldDecorator(v))
        this.getSlideUserList()
        this.getSlideConfig()
    },
    mounted () {
    }
};
</script>
<style lang="less" scoped>
:deep(.ant-card-head) {
    background: #fafafa;
    .ant-card-head-title {
        font-weight: bold;
    }
}
</style>